/**
 * @generated SignedSource<<903d13d7370764f4c6f491c1197ac007>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type issueRealtimeUpdater_nativeIssueTable_project$data = {
  readonly key: string;
  readonly projectId: string;
  readonly " $fragmentType": "issueRealtimeUpdater_nativeIssueTable_project";
};
export type issueRealtimeUpdater_nativeIssueTable_project$key = {
  readonly " $data"?: issueRealtimeUpdater_nativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"issueRealtimeUpdater_nativeIssueTable_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "issueRealtimeUpdater_nativeIssueTable_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "projectId"
      },
      "action": "THROW",
      "path": "projectId"
    },
    {
      "kind": "ScalarField",
      "name": "key"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "b1204633d642be65abab076d2071551e";

export default node;
